import React from 'react';
import colors from '../Theme/colors';

interface DoneAllProperties {
  fill?: string;
}

const DoneAll = ({ fill = colors.greyDark }: DoneAllProperties) => (
  <svg
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      /* eslint-disable-next-line max-len */
      d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
      fill={fill}
    />
  </svg>
);

export default DoneAll;
